import React from 'react';

const NoPermissionMessage = (props) => {
  let msg = props.message || 'Not allowed';
  return (
    <div className="card">
      <div className="card-header">
        <span className="not-found-msg"><i className="fa fa-exclamation-triangle mr-05 color-yellow"></i>{msg}</span>
      </div>
    </div>

  )
}

export default NoPermissionMessage
